export default __webpack_public_path__ + "static/media/15.fe7573d1.webp";